



















import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class BigEventDetails extends Vue {
  external_links: string = ''
  news_title: string = ''
  news_content: string = ''
  creeTime: string = ''

  created() {
    const { external_links, news_title, news_content, creeTime } = this.$route.params
    this.external_links = external_links
    this.news_title = news_title
    this.news_content = news_content
    this.creeTime = creeTime
  }

  back(): void {
    this.$router.go(-1)
  }
}
